import useSWR from 'swr';
import { CourseService } from '../../api';

export const useCourse = (courseId: string | undefined) => {
  const { data, isLoading } = useSWR(courseId ? `getCourse-${courseId}` : null, () =>
    CourseService.getCourse(courseId!),
  );

  return { courseData: data ?? null, isCourseLoading: isLoading };
};
